import React from "react";
import { ArrowRight, CheckGreen, CheckBlue } from "@speedoc/design-assets/build/icons/index.js";
import { useGlobalContext } from "../../utils/globalContext";
import { Link } from "react-router-dom";
import { slugToCountryPathname, wordEllipsis } from "../../utils/strings";
import { useMediaQuery } from "react-responsive";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BundleCard = ({ content, isAnimated }) => {
  const { Trans } = useGlobalContext();
  const isTablet = useMediaQuery({ query: "(max-width: 1112px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  const defineBackgroundColor = value => {
    switch (value) {
      case 1:
        return { backgroundColor: "#CEEEEE" };
      case 2:
        return { backgroundColor: "#9BDDDC" };
      case 3:
        return { backgroundColor: "#7FD4D3" };
      case 4:
        return { backgroundColor: "#E7F7F7" };
      default:
        return { backgroundColor: "#7FD4D3" };
    }
  };

  const defineCheckIcon = value => {
    switch (value) {
      case 1:
        return <CheckGreen />;
      case 2:
        return <CheckBlue />;
      case 3:
        return <CheckGreen />;
      case 4:
        return <CheckBlue />;
      default:
        return <CheckGreen />;
    }
  };

  const defineColor = value => {
    switch (value) {
      case 1:
        return { color: "#2DA5A1" };
      case 2:
        return { color: "#138A87" };
      case 3:
        return { color: "#1C7774" };
      case 4:
        return { color: "#3CA9A6" };
      default:
        return { color: "#1C7774" };
    }
  };

  return (
    <Link to={slugToCountryPathname(content.link)}>
      <div className={`bundleCard ${isAnimated ? "animated" : ""}`}>
        <div className="left">
          <LazyLoadImage
            src={isMobile && content?.mobileImage?.url ? content?.mobileImage?.url : content.image?.url}
            alt="bundle"
            effect="blur"
          />
        </div>

        <div className="right">
          <div className="top">
            <div className="title">
              <Trans>{content.title}</Trans>
            </div>

            <div className="description">
              {" "}
              {isTablet
                ? wordEllipsis(content.description, 80)
                : isMobile
                ? wordEllipsis(content.description, 60)
                : content.description}
            </div>
          </div>

          <div className="bottom">
            <div className="tags">
              {content.tags.map((tag, i) => (
                <div key={i} className="tag" style={defineBackgroundColor(tag.value)}>
                  <span style={defineColor(tag.value)} className="text">
                    {tag.text}
                  </span>
                  {defineCheckIcon(tag.value)}
                </div>
              ))}
            </div>

            <div className={`pricing ${!content.price && !content.priceUponRequest ? "flex-end" : ""}`}>
              <span className="priceBox">
                {content.priceUponRequest && <span className="from">Price upon request</span>}
                {content.price && (
                  <span>
                    <span className="from">from </span>
                    <span className="price">{content.price}</span>
                    <span className="priceDetails">{content.priceDetails}</span>
                  </span>
                )}
              </span>
              <div className="arrow">
                <ArrowRight />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BundleCard;
